// extracted by mini-css-extract-plugin
export var md = "_4c-4";
export var semantic = "_4c-5";
export var sm = "_4c-3";
export var text = "_4c-6";
export var toggleInput = "_4c-0";
export var toggleSwitch = "_4c-1";
export var xs = "_4c-2";